import angular from 'angular'

import ValidationRules        from 'json!./validation-rules.json'

import VinValidator           from './vin.validator'
import CompareToValidator     from './compare-to.validator'
import DifferentFromValidator from './different-from.validator'
import IframeLoad             from './iframe-load.js'
import SubmitForm             from './submit-form.js'
import AutoFill               from './auto-fill.js'
import PasswordValidator      from './password.validator'

let module = angular.module('validators', [])
.constant('ValidationRules', ValidationRules)
.directive('checkVin', VinValidator)
.directive('compareTo', CompareToValidator)
.directive('differentFrom', DifferentFromValidator)
.directive('iframeLoad', IframeLoad)
.directive('submitForm', SubmitForm)
.directive('autoFill', AutoFill)
.directive('checkPassword', PasswordValidator)
.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/validators/index.js